"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiHost = void 0;
// export const apiHost = 'http://localhost:3100';
exports.apiHost = 'https://cdn.growthbook.io';
exports.default = {
    local: 'sdk-5NEWbMQIGyPOa8',
    development: 'sdk-5NEWbMQIGyPOa8',
    staging: 'sdk-bponlMYuv9Go6Z',
    production: 'sdk-WF22dgCwTeaxIsZj',
};
